import { Tabs as MuiTabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocales } from 'src/legacy/locales';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import { useFosterFamilyDetailsNavigatorContext } from './FosterFamilyDetailsNavigatorContext';

export const Tabs = () => {
  const { translate } = useLocales();

  const navigate = useNavigate();

  const { currentTab, id, tabs } = useFosterFamilyDetailsNavigatorContext();

  return (
    <MuiTabs
      onChange={(_, newValue) => {
        navigate(`${PATH_DASHBOARD.fosterFamily.details(id)}/${newValue}`);
      }}
      sx={{
        mb: 2,
        mx: 5,
      }}
      value={currentTab}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          label={`${translate(tab.label)}`}
          value={tab.value}
        />
      ))}
    </MuiTabs>
  );
};
